const geoCountryNames = {
    all: {
        en: 'All',
        ru: 'Все',
    },
    RU: {
        en: 'Russia',
        ru: 'Россия',
    },
    SK: {
        en: 'Slovakia',
        ru: 'Словакия',
    },
    DK: {
        en: 'Denmark',
        ru: 'Дания',
    },
    LT: {
        en: 'Lithuania',
        ru: 'Литва',
    },
    CZ: {
        en: 'Czech Republic',
        ru: 'Чехия',
    },
    FR: {
        en: 'France',
        ru: 'Франция',
    },
    LV: {
        en: 'Latvia',
        ru: 'Латвия',
    },
    CY: {
        en: 'Cyprus',
        ru: 'Кипр',
    },
    NL: {
        en: 'Netherlands',
        ru: 'Нидерланды',
    },
    GE: {
        en: 'Georgia',
        ru: 'Грузия',
    },
    HU: {
        en: 'Hungary',
        ru: 'Венгрия',
    },
    EE: {
        en: 'Estonia',
        ru: 'Эстония',
    },
    AT: {
        en: 'Austria',
        ru: 'Австрия',
    },
    FI: {
        en: 'Finland',
        ru: 'Финляндия',
    },
    ME: {
        en: 'Montenegro',
        ru: 'Черногория',
    },
    KG: {
        en: 'Kyrgyzstan',
        ru: 'Кыргызстан',
    },
    IE: {
        en: 'Ireland',
        ru: 'Ирландия',
    },
    PL: {
        en: 'Poland',
        ru: 'Польша',
    },
    UA: {
        en: 'Ukraine',
        ru: 'Украина',
    },
    PT: {
        en: 'Portugal',
        ru: 'Португалия',
    },
    ES: {
        en: 'Spain',
        ru: 'Испания',
    },
    MT: {
        en: 'Malta',
        ru: 'Мальта',
    },
    MC: {
        en: 'Monaco',
        ru: 'Монако',
    },
    NO: {
        en: 'Norway',
        ru: 'Норвегия',
    },
    IT: {
        en: 'Italy',
        ru: 'Италия',
    },
    RO: {
        en: 'Romania',
        ru: 'Румыния',
    },
    BG: {
        en: 'Bulgaria',
        ru: 'Болгария',
    },
    SI: {
        en: 'Slovenia',
        ru: 'Словения',
    },
    RS: {
        en: 'Serbia',
        ru: 'Сербия',
    },
    MD: {
        en: 'Moldova',
        ru: 'Молдова',
    },
    BY: {
        en: 'Belarus',
        ru: 'Беларусь',
    },
    TR: {
        en: 'Turkey',
        ru: 'Турция',
    },
    GB: {
        en: 'Great Britain',
        ru: 'Великобритания',
    },
    UK: {
        en: 'United Kingdom',
        ru: 'Великобритания',
    },
    IS: {
        en: 'Iceland',
        ru: 'Исландия',
    },
    HR: {
        en: 'Croatia',
        ru: 'Хорватия',
    },
    GR: {
        en: 'Greece',
        ru: 'Греция',
    },
    SE: {
        en: 'Sweden',
        ru: 'Швеция',
    },
    BE: {
        en: 'Belgium',
        ru: 'Бельгия',
    },
    CH: {
        en: 'Switzerland',
        ru: 'Швейцария',
    },
    DE: {
        en: 'Germany',
        ru: 'Германия',
    },
    LU: {
        en: 'Luxembourg',
        ru: 'Люксембург',
    },
    US: {
        en: 'United States',
        ru: 'США',
    },
    CA: {
        en: 'Canada',
        ru: 'Канада',
    },
    AU: {
        en: 'Australia',
        ru: 'Австралия',
    },
    SG: {
        en: 'Singapore',
        ru: 'Сингапур',
    },
    HK: {
        en: 'Hong Kong',
        ru: 'Гонконг',
    },
    MY: {
        en: 'Malaysia',
        ru: 'Малайзия',
    },
    UZ: {
        en: 'Uzbekistan',
        ru: 'Узбекистан',
    },
    PF: {
        en: 'French Polynesia',
        ru: 'Французская Полинезия',
    },
    AE: {
        en: 'United Arab Emirates',
        ru: 'ОАЭ',
    },
    NZ: {
        en: 'New Zealand',
        ru: 'Новая Зеландия',
    },
    JP: {
        en: 'Japan',
        ru: 'Япония',
    },
    KZ: {
        en: 'Kazakhstan',
        ru: 'Казахстан',
    },
    AZ: {
        en: 'Azerbaijan',
        ru: 'Азербайджан',
    },
    AM: {
        en: 'Armenia',
        ru: 'Армения',
    },
    TJ: {
        en: 'Tajikistan',
        ru: 'Таджикистан',
    },
    IL: {
        en: 'Israel',
        ru: 'Израиль',
    },
};

export const getGeoCountryName = (geoCode, lang = 'ru') => {
    if (!geoCode) {
        return '';
    }

    const normalizedGeoCode = String(geoCode).trim();
    const countryNames = geoCountryNames[normalizedGeoCode];

    if (!countryNames) {
        return normalizedGeoCode;
    }

    return countryNames[lang] || countryNames.en || normalizedGeoCode;
};

export const getGeoFlagPath = (geoCode) => {
    if (!geoCode) {
        return null;
    }

    const normalizedGeoCode = String(geoCode).trim().toUpperCase();

    if (normalizedGeoCode === 'ALL') {
        return null;
    }

    return `/flags/geo/${normalizedGeoCode.toLowerCase()}.svg`;
};

const normalizeGeoOptionValue = (item) => {
    if (typeof item === 'string' || typeof item === 'number') {
        return String(item).trim();
    }

    if (item && typeof item === 'object') {
        const value = item.value ?? item.id ?? item.key ?? item.code ?? item.name;
        return value === undefined || value === null ? '' : String(value).trim();
    }

    return '';
};

export const mapGeoOptions = (items, lang = 'ru') => {
    return (items || [])
        .map((item) => {
            const value = normalizeGeoOptionValue(item);

            if (!value) {
                return null;
            }

            return {
                value,
                label: getGeoCountryName(value, lang),
                iconPath: getGeoFlagPath(value),
            };
        })
        .filter(Boolean);
};
